import { useQueryStates, parseAsArrayOf, parseAsInteger } from 'nuqs'

export const useVndlyIssuesFiltersQueryState = () => {
  return useQueryStates(
    {
      instanceIds: parseAsArrayOf(parseAsInteger),
      companyIds: parseAsArrayOf(parseAsInteger),
    },
    {
      urlKeys: {
        instanceIds: 'instance-ids',
        companyIds: 'company-ids',
      },
    }
  )
}
